import React from 'react';

import { Container, Group, Stack, Title } from '@mantine/core';
import { AIConnectCard, ClaudeSetupInstructions } from 'components/AIConnect';
import PageHeader from 'components/PageHeader';

const ClaudeIntegration = (): JSX.Element => {
  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Claude AI
          </Title>
        </Group>
      </PageHeader>

      <div style={{ overflowY: 'scroll' }}>
        <Container maw='980px' py='md'>
          <Stack>
            <ClaudeSetupInstructions />
            <AIConnectCard withGuidance={false} />
          </Stack>
        </Container>
      </div>
    </>
  );
};

export default ClaudeIntegration;
